var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaregiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6099 11.205L16.8026 6.17492C15.9991 5.56158 15.003 5.30039 13.9963 5.4344C13.2418 5.53642 12.5535 5.85351 11.9991 6.3458C11.4447 5.85356 10.7565 5.53642 10.0019 5.4344C9.00147 5.2998 8.00099 5.56104 7.16344 6.20134L1.38827 11.205C1.17421 11.3918 1.13991 11.8442 1.29968 12.055C4.39776 16.1534 8.42459 18.6 11.9991 18.6C15.5735 18.6 19.6003 16.1535 22.6984 12.055C22.8637 11.837 22.8225 11.3905 22.6099 11.205ZM14.1747 11.9997L13.0547 12.7402C12.4129 13.1642 11.5853 13.1642 10.9435 12.7402L9.82345 11.9997C9.63917 11.8779 9.4446 11.7767 9.24949 11.6777C9.4446 11.5786 9.63917 11.4775 9.82345 11.3556L10.9435 10.6151C11.5853 10.1911 12.4129 10.1911 13.0547 10.6151L14.1747 11.3556C14.359 11.4774 14.5536 11.5786 14.7487 11.6777C14.5535 11.7767 14.359 11.8778 14.1747 11.9997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregiver);
export default __webpack_public_path__ + "static/media/Caregiver.2e74381481ef6514c414e0e382caa190.svg";
export { ForwardRef as ReactComponent };